module.exports = __webpack_public_path__ + "img/chevron-left.0b4377a5.svg";